import { memo } from "react";

import { isPresent, noop } from "neetocist";
import { Typography } from "neetoui";

import HelpPopover from "components/HelpPopover";

import Item from "./Item";
import { isValuePresent } from "./utils";

const DetailsBlock = ({
  allowMultiline = true,
  details,
  handleCancel = noop,
  handleSubmit = noop,
  helpPopoverProps,
  iconSize,
  showIcons = false,
  title = "",
}) => (
  <div className="mb-4" data-testid="details-block-items-parent">
    {title && (
      <div className="mb-2 flex items-center gap-2">
        <Typography
          className="neeto-ui-text-gray-700"
          style="h5"
          textTransform="uppercase"
          weight="bold"
        >
          {title}
        </Typography>
        {isPresent(helpPopoverProps) && <HelpPopover {...helpPopoverProps} />}
      </div>
    )}
    {details
      .filter(detail => detail.isEditable || isValuePresent(detail))
      .map((detail, index) => (
        <Item
          {...{
            allowMultiline,
            handleCancel,
            handleSubmit,
            iconSize,
            showIcons,
          }}
          item={detail}
          key={index}
        />
      ))}
  </div>
);

export default memo(DetailsBlock);
